<template>
  <div>
    <div class="form-group">
      <label>後期高齢者医療保険情報</label>
      <br />
      <select class="select-control" v-model="medicalInsuranceSelected" @change="changeMedicalInsurance">
        <option v-for="medicalInsuranceOption in medicalInsuranceOptions" v-bind:value="medicalInsuranceOption.value">
          {{ medicalInsuranceOption.text }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>身体障害者手帳</label>
      <br />
      <select class="select-control" v-model="disabilityCertificateSelected" @change="changeHandicappedNotebook">
        <option v-for="disabilityCertificateOption in disabilityCertificateOptions" v-bind:value="disabilityCertificateOption.value">
          {{ disabilityCertificateOption.text }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label>療育手帳</label>
      <br />
      <select class="select-control" v-model="rehabilitationNotebookSelected" @change="changeRehabilitationNotebook">
        <option v-for="rehabilitationNotebookOption in rehabilitationNotebookOptions" v-bind:value="rehabilitationNotebookOption.value">
          {{ rehabilitationNotebookOption.text }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label>精神障害者保健福祉手帳</label>
      <br />
      <select class="select-control" v-model="mentalIllnessSelected" @change="changeMentalNotebook">
        <option v-for="mentalIllnessOption in mentalIllnessOptions" v-bind:value="mentalIllnessOption.value">
          {{ mentalIllnessOption.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "NursingPage2",
  data() {
    return {
      rehabilitationNotebookSelected: 0,
      mentalIllnessSelected: 0,
      medicalInsuranceSelected: 0,
      disabilityCertificateSelected: 0,
      rehabilitationNotebookOptions: [
        { text: "選択してください", value: 0 },
        { text: "なし", value: 1 },
        { text: "A", value: 2 },
        { text: "B", value: 3 },
      ],
      mentalIllnessOptions: [
        { text: "選択してください", value: 0 },
        { text: "なし", value: 1 },
        { text: "１級", value: 2 },
        { text: "２級", value: 3 },
        { text: "３級", value: 4 },
      ],
      medicalInsuranceOptions: [
        { text: "選択してください", value: 0 },
        { text: "非該当", value: 1 },
        { text: "１割負担", value: 2 },
        { text: "３割負担", value: 3 },
      ],
      disabilityCertificateOptions: [
        { text: "選択してください", value: 0 },
        { text: "なし", value: 1 },
        { text: "１級", value: 2 },
       { text: "２級", value: 3 },
       { text: "３級", value: 4 },
       { text: "４級", value: 5 },
       { text: "５級", value: 6 },
       { text: "６級", value: 7 },
       { text: "７級", value: 8 },
      ],
    };
  },
  methods: {
    changeMedicalInsurance() {
      this.$emit("handle-change-medical-insurance", this.medicalInsuranceSelected)
    },
    changeHandicappedNotebook() {
      this.$emit("handle-change-handicapped-notebook", this.disabilityCertificateSelected)
    },
    changeRehabilitationNotebook() {
      this.$emit("handle-change-rehabilitation-notebook", this.rehabilitationNotebookSelected)
    },
    changeMentalNotebook() {
      this.$emit("handle-change-mental-notebook", this.mentalIllnessSelected)
    }
  }
};
</script>

<style scoped>
select option:first-child {
  display: none;
}
.medical-history {
  margin-top: 2%;
}

label {
  margin-right: 5px; /* ボタン同士の間隔 */
}

label input {
  display: none; /* デフォルトのinputは非表示にする */
}

label span {
  color: gray;
  font-size: 1rem;
  border: 1px solid gainsboro; /* 淵の線を指定 */
  border-radius: 20px; /* 角丸を入れて、左右が丸いボタンにする */
  padding: 3% 5%; /* 上下左右に余白をトル */
  display: inline-block;
  min-width: 34%;
  text-align: center;
  margin-bottom: 3%;
}
</style>



// WEBPACK FOOTER //
// src/templates/NursingPage2.vue